import 'src/styles/ui/stepper.css';

import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Stepper — horizontal wizard progress: numbered dots connected by lines with
 * labels underneath. Done steps show a green check; the current step is ringed.
 *
 * @param {Object} props
 * @param {Array<{key: string, label: string}>} props.steps - Ordered steps
 * @param {number} props.activeIndex - Index of the current step
 */
const Stepper = ({ steps, activeIndex, className }) => (
  <div className={classNames('stepper', className)}>
    {steps.map((step, index) => {
      const isDone = index < activeIndex;
      const isCurrent = index === activeIndex;
      return (
        <div
          key={step.key}
          className={classNames('stepper__step', {
            'stepper__step--done': isDone,
            'stepper__step--current': isCurrent,
          })}
        >
          <span className='stepper__dot'>
            {isDone ? <FontAwesomeIcon icon={faCheck} /> : index + 1}
          </span>
          <span className='stepper__label'>{step.label}</span>
        </div>
      );
    })}
  </div>
);

Stepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeIndex: PropTypes.number.isRequired,
  className: PropTypes.string,
};

Stepper.defaultProps = { className: '' };

export default Stepper;
